<mat-card>
  <mat-card-header class="center card-header">
    <mat-card-title *ngIf="!options?.plugins?.title?.display">
      {{ options?.plugins?.title?.text }}
    </mat-card-title>
  </mat-card-header>
  <mat-card-content class="chart-content">
    <mat-spinner *ngIf="!chartData" [diameter]="30" class="center-middle" color="primary"></mat-spinner>

    <app-no-content *ngIf="chartData && !chartData.length"
                    [compact]="true"
                    [title]="noContentTitle"
                    [details]="noContentDetails"></app-no-content>

    <div *ngIf="chartData && chartData.length" class="full-width">
      <canvas baseChart
              [type]="type"
              [height]="height"
              [legend]="false"
              [labels]="labels"
              [options]="options"
              [datasets]="dataset">
      </canvas>
    </div>
  </mat-card-content>
</mat-card>
